
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
import './App.css';
import './media.css';
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import { RenderRout } from './router';
window.bootstrap = bootstrap;
function App() {
  return (
     <HelmetProvider>
    <LanguageProvider>
      <RenderRout/>
    </LanguageProvider>
    </HelmetProvider>
 
  );
}

export default App;
